import { UndefinedInitialDataInfiniteOptions } from "@tanstack/react-query";
import { omit } from "lodash";

export const createInfiniteQuery = <
  T extends {
    sort?: string;
    // Strapi v4 accepts either a comma-string shortcut ("deep,2", "image")
    // or a nested object that qs-serializes to populate[...] params.
    // Allowing both lets callers pick selective populate for card grids
    // without weakening type safety elsewhere.
    populate?: string | Record<string, unknown>;
    pagination?: {
      pageSize: number;
    };
  },
  R extends {
    meta: {
      pagination?: {
        pageCount: number;
      };
    };
  },
>(
  key: (string | number)[],
  fn: (args: T) => Promise<R>,
  defaultOptions?: UndefinedInitialDataInfiniteOptions<R>,
): ((args: T) => UndefinedInitialDataInfiniteOptions<R>) => {
  return (args) => {
    return {
      queryKey: [...key, args],
      queryFn: async ({ pageParam = 1 }) => {
        const data = await fn({
          ...args,
          pagination: {
            ...args.pagination,
            page: pageParam,
          },
        });
        return data;
      },
      getNextPageParam: (lastPage, pages) => {
        const pageCount = lastPage.meta.pagination?.pageCount ?? 1;
        return pages.length < pageCount ? pages.length + 1 : undefined;
      },
      //
      ...omit(defaultOptions, ["queryKey", "getNextPageParam"]),
    };
  };
};
